type Categories ={
    title: string
    data: any[]
}
const CategoryObj :Categories = {
    title: 'Category',
    data: [
        {
            value: "all",
            name: "All",
        },
        {
            value: "Art",
            name: "Art",
        },
        {
            value: "Biography",
            name: "Biography",
        },
        {
            value: "Computers",
            name: "Computers",
        },
        {
            value: "History",
            name: "History",
        },
        {
            value: "Medical",
            name: "Medical",
        },
        {
            value: "Poetry",
            name: "Poetry",
        },
    ]
}
export default CategoryObj;